module.exports = __webpack_public_path__ + "img/logo-icon.8491c3bd.png";